<template>
    <div class="ThinChart">
        <span
            class="ThinChart__green"
            :style="greenStyle"
        ></span>
        <span
            class="ThinChart__red"
            :style="redStyle"
        ></span>
    </div>
</template>
<script>
export default {
    name: 'ThinChart',
    props: {
        percent: {
            type: Number,
            required: true,
        },
    },
    computed: {
        greenStyle(){
            return {
                width: `${this.percent}%`,
                'border-top-right-radius': this.percent === 100 ? '4px' : 0,
                'border-bottom-right-radius': this.percent === 100 ? '4px' : 0,
            };
        },
        redStyle(){
            return {
                width: `${100 - this.percent}%`,
                'border-top-left-radius': this.percent === 0 ? '4px' : 0,
                'border-bottom-left-radius': this.percent === 0 ? '4px' : 0,
            };
        }
    }
};
</script>
<style lang="scss">
    .ThinChart {
        width: 100%;
        height: 0.5rem;
        display: flex;
        border-radius: 4px;

        &__green {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            background: $gradient-positive;
        }
        &__red {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            background: $gradient-negative;
        }
    }
</style>
